export default "__VITE_ASSET__94871a70__"